// hooks/useAlert.js
import Swal from 'sweetalert2';
import colors from '../theme/colors';

const BaseSwal = Swal.mixin({
	customClass: {
		popup: 'swal-custom-popup',
	},
});

const useAlert = () => {
	const success = (title, text = '') => {
		return BaseSwal.fire({
			title,
			text,
			icon: 'success',
			confirmButtonColor: colors.primary,
			confirmButtonText: 'OK',
		});
	};

	const error = (title, text = '') => {
		return BaseSwal.fire({
			title,
			text,
			icon: 'error',
			confirmButtonColor: colors.primary,
			confirmButtonText: 'OK',
		});
	};

	const warning = (title, text = '') => {
		return BaseSwal.fire({
			title,
			text,
			icon: 'warning',
			confirmButtonColor: colors.primary,
			confirmButtonText: 'OK',
		});
	};

	const confirm = (title, text = '', confirmText = 'Yes', cancelText = 'Cancel') => {
		return BaseSwal.fire({
			title,
			text,
			icon: 'question',
			showCancelButton: true,
			confirmButtonColor: colors.primary,
			cancelButtonColor: '#d33',
			confirmButtonText: confirmText,
			cancelButtonText: cancelText,
		});
	};

	const toast = (title, icon = 'success', timer = 3000) => {
		return BaseSwal.fire({
			title,
			icon,
			toast: true,
			position: 'top-end',
			showConfirmButton: false,
			timer,
			timerProgressBar: true,
			background: '#fff',
			color: '#333',
			iconColor: colors.primary,
			customClass: {popup: 'swal-toast-popup'},
		});
	};

	const close = () => BaseSwal.close();

	const loading = (title = 'Loading...', text = '') => {
		return BaseSwal.fire({
			title,
			text,
			allowOutsideClick: false,
			allowEscapeKey: false,
			showConfirmButton: false,
			willOpen: () => BaseSwal.showLoading(),
		});
	};

	const primary = (title, text = '') => {
		return BaseSwal.fire({
			title,
			text,
			icon: 'info',
			confirmButtonColor: colors.primary,
			confirmButtonText: 'OK',
		});
	};

	return {
		success,
		error,
		warning,
		confirm,
		toast,
		primary,
		loading,
		close,
		fire: BaseSwal.fire,
	};
};

export default useAlert;
